import { z } from "zod";

const capioAhcSiteIds = [
  "stGoran",
  "norrtalje",
  "taby",
  "vasterort",
  "sollentuna",
  "dalen",
  "handen",
  "nacka",
  "sodertalje",
  "haga",
] as const;
const medomaSiteIds = ["vasastan", "kungsholmen"] as const;
const hahagSiteIds = ["hhagZollikon"] as const;
const ksgrSiteIds = ["chur"] as const;
const rakusSiteIds = ["rakus"] as const;
const qaSiteIds = ["norra", "sodra"] as const;
const slsoSiteIds = [
  "solnastrand",
  "danderyd",
  "jarfalla",
  "nacka",
  "handen",
  "huddinge",
  "ost",
  "vast",
] as const;
const sshSiteIds = ["bromma", "innerstaden"] as const;
const susSiteIds = ["malmo", "lund"] as const;

export const siteIdSchema = z.enum([
  ...capioAhcSiteIds,
  ...medomaSiteIds,
  ...hahagSiteIds,
  ...ksgrSiteIds,
  ...rakusSiteIds,
  ...qaSiteIds,
  ...slsoSiteIds,
  ...sshSiteIds,
  ...susSiteIds,
]);
export type SiteId = z.infer<typeof siteIdSchema>;

export const siteSchema = z.object({
  id: siteIdSchema,
  displayName: z.string(),
});
export type ISite = z.infer<typeof siteSchema>;
